export default __webpack_public_path__ + "../images/advantage-2.jpg";